"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/credit-monitor-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Fcredit-monitor-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditMonitorServiceClient = exports.EnrollUserResponse = exports.EnrollUserRequest = exports.GetCreditDataResponse = exports.GetCreditDataRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const user_credit_data_1 = require("./user-credit-data");
const protobufPackage = 'com.step.creditmonitor.proto';
function createBaseGetCreditDataRequest() {
    return {};
}
exports.GetCreditDataRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCreditDataRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCreditDataRequest();
        return message;
    },
};
function createBaseGetCreditDataResponse() {
    return { creditData: user_credit_data_1.UserCreditData.fromPartial({}) };
}
exports.GetCreditDataResponse = {
    fromJSON(object) {
        const message = {
            creditData: isSet(object.creditData)
                ? user_credit_data_1.UserCreditData.fromJSON(object.creditData)
                : user_credit_data_1.UserCreditData.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.creditData !== undefined) {
            obj.creditData = user_credit_data_1.UserCreditData.toJSON(message.creditData);
        }
        return obj;
    },
    create(base) {
        return exports.GetCreditDataResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCreditDataResponse();
        message.creditData = (object.creditData !== undefined && object.creditData !== null)
            ? user_credit_data_1.UserCreditData.fromPartial(object.creditData)
            : user_credit_data_1.UserCreditData.fromPartial({});
        return message;
    },
};
function createBaseEnrollUserRequest() {
    return {};
}
exports.EnrollUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnrollUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnrollUserRequest();
        return message;
    },
};
function createBaseEnrollUserResponse() {
    return {};
}
exports.EnrollUserResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnrollUserResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnrollUserResponse();
        return message;
    },
};
/**
 * Credit Monitor Service API.
 */
class CreditMonitorServiceClient {
    rpc;
    name = 'com.step.creditmonitor.proto.CreditMonitorService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/credit-monitor';
    methods = [{
            name: 'EnrollUser',
            requestType: exports.EnrollUserRequest,
            responseType: exports.EnrollUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCreditData',
            requestType: exports.GetCreditDataRequest,
            responseType: exports.GetCreditDataResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Enroll user into credit monitoring.
     */
    enrollUser(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get user's credit score data.
     */
    getCreditData(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CreditMonitorServiceClient = CreditMonitorServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=credit-monitor-service.js.map